import React, { Component } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import { Button } from 'reactstrap'
import { toast } from 'react-toastify'

import { trackGAEvent } from '../utilities/tracking'
import { filterPlants } from '../utilities/helpers'
import {
    getPlantList,
    togglePlantSearch,
    changeSearchQuery,
    togglePlantFilter,
    loadPlantList,
    loadPlantSearch,
    getFavoritePlants,
    resetPlantSearch,
    resetPlantFilters,
    getUserProfile
} from '../../actions'
import PlantListItem from '../Plant/PlantListItem'
import SearchHeader from '../Plant/SearchHeader'
import LoadingSpinner from '../Global/LoadingSpinner'
import { FillerDiv, CenteredDiv, DivWithMargin, CenteredDivWithMargin } from '../StyledComponents/Fillers'
import FABButton from '../Global/FABButton'
import { InfoToastContainer } from '../StyledComponents/Global/Toast'
import FilterView from '../Plant/FilterView'

const loadingComponent = (
    <CenteredDiv>
        <LoadingSpinner /><DivWithMargin bottom="50" important />
    </CenteredDiv>
)

class PlantListPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            filterOpen: false,
        }

        this.loadFavorites = this.loadFavorites.bind(this)
        this.onResetSearch = this.onResetSearch.bind(this)
        this.loadNext = this.loadNext.bind(this)
        this.onFilterviewClose = this.onFilterviewClose.bind(this)
    }

    componentDidMount() {
        const {
            loadList, getList, toggleSearch, page, plantList,
            mode, filters, searchQuery, sessionState, getProfile,
        } = this.props

        this.loadFavorites()

        if (page === 1 && isEmpty(plantList)) {
            loadList()
            getList(searchQuery, filters, page)
        }

        if (!!sessionState && !!sessionState.idToken && !sessionState.gardenKnowledge) {
            const { token } = sessionState.idToken
            getProfile(sessionState.authUser.uid, token)
        }

        if (mode.mode === 'add-plant') {
            // seems as autoclose won't work but keep it if it will be supported in the future
            toast('Füge eine Pflanze zum Sensor hinzu!', {
                position: 'top-center',
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 50,
            })
        }

        toggleSearch(false)
        window.scrollTo(0, 0)
    }

    componentDidUpdate(prevProps) {
        const { sessionState, getProfile } = this.props
        if (!prevProps.sessionState.idToken && !!sessionState.idToken) {
            this.loadFavorites()
            if (!sessionState.gardenKnowledge) {
                const { token } = sessionState.idToken
                getProfile(sessionState.authUser.uid, token)
            }
        }
    }

    onFilterviewClose(filtersChanged) {
        this.setState({ filterOpen: false })

        if (filtersChanged) {
            const {
                resetFilters, getList, searchQuery, filters, sessionState,
            } = this.props

            trackGAEvent('interaction', {
                interaction_value: 'undefined',
                interaction_category: 'Plant-List',
                interaction_action: 'plant-filter-request',
                interaction_label: `${sessionState.gardenKnowledge || 'NOT_SPECIFIED'}`,
            })
            resetFilters()
            getList(searchQuery, filters, 1)
        }
    }

    onResetSearch() {
        const { resetSearch, getList, filters } = this.props
        resetSearch()
        getList('', filters, 1)
    }

    loadFavorites() {
        const {
            getFavorites, favoritePlants, sessionState,
        } = this.props

        if (isEmpty(favoritePlants.favorites)
            && !!sessionState.idToken
            && sessionState.authUser.uid) {
            getFavorites(sessionState.authUser.uid, sessionState.idToken.token)
        }
    }

    loadNext() {
        const {
            searchQuery,
            page,
            loadList,
            getList,
            filters,
        } = this.props

        loadList()
        getList(searchQuery, filters, page)
    }

    renderList() {
        const {
            plantList, favoritePlants, listIsLoading, filters, searchQuery,
        } = this.props

        let filteredList = filterPlants(plantList, filters, favoritePlants.favorites)
        // TODO: remove when backend data is correct and outputs correct id
        filteredList = filteredList.filter(plant => !window.Number.isNaN(parseInt(plant.id, 10)))

        if (isEmpty(filteredList) && !listIsLoading) {
            const resetSearchButton = isEmpty(searchQuery)
                ? null
                : (
                    <FillerDiv>
                        <Button color="secondary" size="sm" onClick={this.onResetSearch}>Suche zurücksetzen</Button>
                        <br /><br />
                    </FillerDiv>
                )

            return (
                <CenteredDiv>
                    <DivWithMargin bottom="20" important>
                        Keine Pflanzen passen zu deinen Filtern...
                    </DivWithMargin>
                    <DivWithMargin bottom="50" important>
                        {resetSearchButton}
                        <Button color="secondary" size="sm" onClick={() => this.setState({ filterOpen: true })}>Filter anpassen</Button>
                    </DivWithMargin>
                </CenteredDiv>
            )
        }

        return filteredList.map(plant => (
            <PlantListItem plant={plant} key={plant.id} />
        ))
    }

    render() {
        const {
            filters,
            toggleSearch,
            getList,
            changeQuery,
            toggleFilter,
            isLast,
            listIsLoading,
            sessionState,
            searchQuery,
            searchActive,
        } = this.props

        if (this.state.filterOpen) {
            return (<FilterView
                filters={filters}
                onClose={this.onFilterviewClose}
                onFilterChange={toggleFilter}
                authUser={sessionState ? sessionState.authUser : null}
            />)
        }

        const items = this.renderList()

        const loadingSpinner = listIsLoading
            ? loadingComponent
            : null

        const loadMore =
            (isLast || listIsLoading)
            || (items.type && items.type.name === 'StyledComponent')
                ? null
                : (
                    <CenteredDivWithMargin top="20" bottom="20" important>
                        <Button color="info" size="sm" onClick={() => this.loadNext()}>Mehr laden</Button>
                    </CenteredDivWithMargin>
                )

        return (
            <FillerDiv>
                <InfoToastContainer
                    className="toast-container"
                    toastClassName="info-toast"
                />
                <SearchHeader
                    searchQuery={searchQuery}
                    searchFilters={filters}
                    searchActive={searchActive}
                    onSearchTrigger={getList}
                    onSearchClear={this.onResetSearch}
                    onSearchQueryChange={changeQuery}
                    onSearchClose={() => toggleSearch(false)}
                    userSession={sessionState}
                />
                {items}
                {loadingSpinner}
                {loadMore}
                <FABButton
                    items={['search', 'visual-recognititon', 'filter']}
                    onSearchClicked={() => {
                        trackGAEvent('interaction', {
                            interaction_value: 'undefined',
                            interaction_category: 'Plant-List',
                            interaction_action: 'plant-search-open',
                            interaction_label: `${sessionState.gardenKnowledge || 'NOT_SPECIFIED'}`,
                        })
                        toggleSearch(true)
                    }}
                    onFilterClicked={() => {
                        trackGAEvent('interaction', {
                            interaction_value: 'undefined',
                            interaction_category: 'Plant-List',
                            interaction_action: 'plant-filter-open',
                            interaction_label: `${sessionState.gardenKnowledge || 'NOT_SPECIFIED'}`,
                        })
                        this.setState({ filterOpen: true })
                    }}
                />
            </FillerDiv>
        )
    }
}

const mapStateToProps = state => ({
    plantList: state.plantList.plants,
    isLast: state.plantList.isLast,
    page: state.plantList.page,
    listIsLoading: state.plantList.isLoading,
    searchQuery: state.plantList.query,
    searchActive: state.search.active,
    filters: state.search.filters,
    favoritePlants: state.favoritePlants,
    sessionState: state.sessionState,
    mode: state.mode,
})


export default connect(mapStateToProps, {
    getList: getPlantList,
    loadList: loadPlantList,
    loadSearch: loadPlantSearch,
    toggleSearch: togglePlantSearch,
    toggleFilter: togglePlantFilter,
    changeQuery: changeSearchQuery,
    getFavorites: getFavoritePlants,
    resetSearch: resetPlantSearch,
    resetFilters: resetPlantFilters,
    getProfile: getUserProfile,
})(PlantListPage)



// WEBPACK FOOTER //
// ./src/components/pages/PlantList.js